import { render, staticRenderFns } from "./signature-holders.vue?vue&type=template&id=31f76e75"
import script from "./signature-holders.vue?vue&type=script&lang=js"
export * from "./signature-holders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports